import * as React from "react";
import type { SVGProps } from "react";
const SvgPencil = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#pencil_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.497 3.737a3.83 3.83 0 0 0-2.704 1.056l-.999.999-.001.001-.001.001-9.5 9.499A1 1 0 0 0 3 16v4a1 1 0 0 0 1 1h4a1 1 0 0 0 .707-.293l9.5-9.5 1-1 .023-.024a3.83 3.83 0 0 0-2.733-6.446M17.5 9.086l.28-.28a1.83 1.83 0 0 0-2.586-2.586l-.28.28zm-4-1.172 2.586 2.586-8.5 8.5H5v-2.586z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="pencil_svg__a">
        <path fill="#fff" d="M3 3.67h17.33V21H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPencil;
